var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.72025 15.2158V14.9115L7.372 8.78876L8.2055 9.65001C8.87075 10.337 9.764 10.7158 10.7205 10.7158C11.6767 10.7158 12.57 10.337 13.2352 9.65001L14.0687 8.78901L19.72 14.9113V15.2158H1.72025ZM1.72025 2.95051L6.67525 8.06926L1.72025 13.4373V2.95051ZM19.72 2.95126V13.437L14.7652 8.06926L19.72 2.95126ZM19.72 1.21576V1.51376L12.517 8.95451C12.0415 9.44526 11.4035 9.71576 10.7205 9.71576C10.0372 9.71576 9.39925 9.44526 8.92375 8.95451L1.72025 1.51301V1.21576H19.72ZM20.72 1.70426V0.715759C20.72 0.439759 20.4962 0.215759 20.22 0.215759H1.22025C0.944247 0.215759 0.720247 0.439759 0.720247 0.715759V15.7158C0.720247 15.9918 0.944247 16.2158 1.22025 16.2158H20.22C20.4962 16.2158 20.72 15.9918 20.72 15.7158V1.71201V1.70426Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Email.ee3eae7c0fe7dd6f33e5ab157fd2df2e.svg";